import { render, staticRenderFns } from "./pp_rt1.vue?vue&type=template&id=78791dda&"
import script from "./pp_rt1.vue?vue&type=script&lang=js&"
export * from "./pp_rt1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports